<template>
	<div class="bj">
		<div>
			<div class="content" style="margin-bottom: 6px;">
				<div class="tops">
					<div class="logo"><img src="../assets/index/logo.png" /></div>
					<div class="lxwm"><img src="../assets/lxwm.png" /></div>
				</div>

				<div class="nav">
					<el-row>
						<el-col :span="21">
							<div class="grid-content" @click="goTo('/course')">
								<div :class="{'act': $route.path === '/course'}">全部课程</div>
							</div>
							<div class="x"></div>
							<div class="grid-content" @click="goTo('/courses')">
								<div :class="{'act': $route.path === '/courses'}">我的课程</div>
							</div>
							<div class="x"></div>
							<div class="grid-content" @click="goTo('/examination')">
								<div :class=" {'act': $route.path==='/examination' }">我的考试</div>
							</div>
							<div class="x"></div>
							<div class="grid-content" @click="goTo('/order')">
								<div :class=" {'act': $route.path==='/order' }">我的订单</div>
							</div>
							<div class="x"></div>
							<div class="grid-content" @click="goTo('/certificate')">
								<div :class=" {'act': $route.path==='/certificate' }">我的证书</div>
							</div>
							<div class="x"></div>
						</el-col>
						<el-col :span="3">
							<el-popover placement="bottom" width="150" trigger="click">
								<div class="listbut" @click="dialogVisible=true"><i class="el-icon-user-solid"></i>个人资料
								</div>
								<div class="listbut" @click="pwddialog=true"><i class="el-icon-s-goods"></i>修改密码</div>
								<div class="listbut" @click="logoutCms()"><i class="el-icon-remove"></i>退出登录</div>
								<div class="userinfo" slot="reference">
									<div>
										<img :src="userInfos.avatar" />
									</div>
									<div>{{userInfos.nickname}}<i class="el-icon-caret-bottom"></i></div>
								</div>
							</el-popover>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="router">
				<div class="rou">
					<router-view></router-view>
				</div>
				<Foot></Foot>
			</div>
		</div>

		<!-- 修改个人资料 -->
		<el-dialog title="修改资料" :visible.sync="dialogVisible" width="630px" :before-close="Close">
			<el-form ref="form" :rules="rules" :model="form" label-width="100px">
				<el-form-item label="姓名">
					<el-input v-model="form.nickname" placeholder="请输入真实姓名" :disabled='true' :readonly='true'>
					</el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="mobile">
					<el-input v-model="form.mobile" placeholder="为确保联系到本人，请准确填写有效手机号"></el-input>
				</el-form-item>
				<el-form-item label="身份证号码">
					<el-input v-model="form.card" placeholder="为确保证书合法有效，请准确填写本人身份证件信息" :disabled='true'
						:readonly='true'>
					</el-input>
				</el-form-item>
				<el-form-item label="单位名称">
					<el-input v-model="form.company" placeholder="请准确填写工作单位信息（用于生成证书）" :disabled='true'
						:readonly='true'>
					</el-input>
				</el-form-item>
				<!-- <el-form-item label="教育类型" v-if="form.group_id ===1">
					<el-input v-model="form.learning_type_text" placeholder="请准确填写工作单位信息（用于生成证书）"
						:readonly='true'></el-input>
					 <el-select v-model="form.learning_type" placeholder="请选择教育类别" style="width: 100%;">
						<el-option v-for="item in Learningdata" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="个人免冠照">
					<el-upload class="avatar-uploader" :action="fileimg.uploadUrl" :show-file-list="false"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="form.picture" :src="cdnurl+form.picture" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<div class="upload-but">
						<div>
							<p style="color: #FF0000;">照片上传注意事项</p></br>
							<p>上传电子版照片为近期免冠正面证件照，格式为jpg，大小为50K～100k，2寸照片。</p></br>
							<p>照片必须反清晰反映本人特征，
								<span style="color: #FF0000;">如生活照、照片模糊或虚、红‘X’等情况，</span>
								均不能通过照片审核
							</p></br>
						</div>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="medium" @click="onSubmit('form')">立即保存</el-button>
					<el-button size="medium" @click="dialogVisible=false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="修改密码" :visible.sync="pwddialog" width="630px" :before-close="Closes">
			<el-form ref="formpwd" :rules="pwdrules" :model="formpwd" label-width="100px">
				<el-form-item label="旧密码" prop="pwd">
					<el-input v-model="formpwd.pwd" placeholder="请输入原密码" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="pwd1">
					<el-input v-model="formpwd.pwd1" placeholder="请输入新密码" show-password></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="pwd2">
					<el-input v-model="formpwd.pwd2" placeholder="请输入确认新密码" show-password></el-input>
				</el-form-item>
				<ul class="tips">
					<li>
						1、新密码为大小写字母和数字且至少为8位。
					</li>
					<li>
						2、新密码不应包含用户名。
					</li>
					<li>
						3、新密码不能是键盘排序。
					</li>
					<li>
						4、新密码不能包含特殊符号。
					</li>
				</ul>
				<el-form-item>
					<el-button type="primary" size="medium" @click="submitForm('formpwd')">保存</el-button>
					<el-button size="medium" @click="Closes">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	import Foot from '../components/foot.vue'
	export default {
		components: {
			Foot
		},
		data() {
			return {
				defaultStay: '/course',
				userInfos: {
					nickname: '',
					avatar: '',
				},
				config: {
					logo_big: ''
				},
				cdnurl: this.$https,
				dialogVisible: false,
				pwddialog: false,
				form: {
					nickname: '',
					mobile: '',
					card: '',
					company: '',
					learning_type_text: '',
					type: [],
					resource: '',
					desc: '',
					picture: ''
				},
				rules: {
					mobile: [{
						required: true,
						pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}],
				},
				formpwd: {
					pwd: '',
					pwd1: '',
					pwd2: ''
				},
				pwdrules: {
					pwd: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur'
					}],
					pwd1: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					pwd2: [{
						required: true,
						message: '请输入确认新密码',
						trigger: 'blur'
					}],
				},
				fileimg: {
					uploadUrl: this.$uploadApi,
				},
				imageUrl: '',
			};
		},
		created() {
			this.config = JSON.parse(sessionStorage.getItem('configs'))
			this.userInfos = JSON.parse(sessionStorage.getItem('userInfo'))
			this.form = this.userInfos
			if (this.userInfos.is_changepass === 0) {
				this.pwddialog = true
			}
			// this.defaultStay = sessionStorage.getItem('leftMenuDefaultKey')

		},
		methods: {
			//修改个人资料
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$http({
								method: 'POST',
								url: '/user/upUser',
								headers: {
									requireAuth: true // 这里通过设置requireAuth为true来启用token检查
								},
								data: {
									mobile: this.form.mobile,
									picture: this.form.picture
								}
							})
							.then(response => {
								if (response.code == 1) {
									let userinfo = JSON.parse(sessionStorage.getItem('userInfo'));
									userinfo.mobile = this.form.mobile;
									userinfo.picture = this.form.picture;
									sessionStorage.setItem('userInfo', JSON.stringify(userinfo));
									this.$message({
										message: response.msg,
										type: 'success'
									});
								} else {
									this.$message(response.msg);
								}
							})
							.catch(error => {
								console.log(error)
							})
					}

				})
			},
			//修改密码
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.formpwd.pwd1 === this.formpwd.pwd2) {
							this.$http({
									method: 'POST',
									url: '/user/newresetpwd',
									headers: {
										requireAuth: true // 这里通过设置requireAuth为true来启用token检查
									},
									data: {
										oldpassword: this.formpwd.pwd,
										newpassword: this.formpwd.pwd1
									}
								})
								.then(response => {
									if (response.code == 1) {
										this.$message({
											message: response.msg,
											type: 'success'
										});
										this.formpwd = {
											pwd: '',
											pwd1: '',
											pwd2: ''
										}
										sessionStorage.clear()
										this.$router.replace({
											name: 'login'
										})
									} else {
										this.$message(response.msg);
									}
								})
								.catch(error => {
									console.log(error)
								})
						} else {
							this.$message('两次密码输入不一致！');
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//上传证件照
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
				this.form.picture = file.response.data.url
				console.log(file.response.data.url)
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 124 < 1;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
					return isJPG && isLt2M;
				}
				if (!isLt2M) {
					console.log(isLt2M)
					this.$message.error('上传头像图片大小不能超过 100KB!');
					return isJPG && isLt2M;
				}
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			goTo(path) {
				console.log(path)
				if (this.userInfos.is_changepass === 0) {
					this.pwddialog = true
				} else {
					this.defaultStay = path
					window.sessionStorage.setItem('leftMenuDefaultKey', path)
					this.$router.replace(path);
				}

			},
			Close() {
				this.dialogVisible = false
			},
			Closes() {
				if (this.userInfos.is_changepass === 1) {
					this.pwddialog = false
				}

			},
			// 退出
			logoutCms() {
				this.$confirm('是否继续退出系统?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.showLogout = false
					const loading = this.$loading({
						lock: true,
						text: '正在退出，请稍候...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					})
					setTimeout(() => {
						loading.close()
						sessionStorage.clear()
						this.$message({
							message: '已退出',
							type: 'success'
						})
						this.$router.replace({
							name: 'login'
						})
					}, 2000)
				}).catch(() => {

				});
			}
		}
	};
</script>
<style>
	.el-popover {
		padding: 0 !important;
		width: 148px !important;
		min-width: 148px !important;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5) !important;
		border-radius: 5px !important;
	}

	.bj .el-dialog__header {
		padding: 12px !important;
		background: #1072DA !important;

	}

	.bj .el-dialog__header .el-dialog__title {
		color: #fff !important;
	}

	.bj .el-dialog__header .el-dialog__close {
		color: #fff !important;
	}

	.bj p {
		padding: 0 !important;
		margin: 0 !important;
	}

	body {
		overflow-y: hidden !important;
		padding: 0 !important;
		margin: 0 !important;
	}
</style>

<style scoped>
	.tips {
		overflow: hidden;
		padding: 0 0 10px 100px;
	}

	.tips li {
		font-size: 14px;
		color: red;
		list-style-type: none;
	}

	.bj {
		background-image: url(../assets/bj.jpg);
		background-repeat: no-repeat;
		background-size: 100% auto;

	}

	.content {
		width: 1400px;
		margin: 0 auto;
	}

	.tops {
		overflow: hidden;
	}

	.logo {
		width: 805px;

		padding-top: 43px;
		float: left;
	}

	.logo img {
		width: 805px;
		height: auto;
	}

	.lxwm {
		float: right;
		width: 330px;
		height: 68px;
		padding-top: 43px;
	}

	.lxwm img {
		width: 330px;
		height: auto;
	}

	.nav {
		width: 100%;
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 5px;
		margin-top: 31px;
	}

	.grid-content {
		width: 168px;
		height: 46px;
		text-align: center;
		float: left;
		line-height: 50px;
		font-size: 18px;
		color: #515151;
		cursor: pointer;
	}

	.grid-content div {
		width: 114px;
		height: 45px;
		margin: 0 auto;
	}

	.grid-content div:hover {
		color: #1072DA;
		border-bottom: 3px solid #1072DA;
	}

	.act {
		color: #1072DA;
		border-bottom: 3px solid #1072DA;
	}

	.x {
		float: left;
		height: 25px;
		margin-top: 13px;
		border-left: 1px solid #D4D4D4;
	}

	.router {
		width: 100%;
		height: calc(100vh - 216px);
		overflow-y: auto;
		margin-top: 0 auto;

	}

	/* 滚动条整体 */
	.router::-webkit-scrollbar {
		height: 20px;
		width: 1px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.router::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.router::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.router::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.rou {
		width: 1400px;
		margin: 0px auto;
		background: #FFFFFF;
	}

	.userinfo {
		height: 35px;
		margin-top: 8px;
		cursor: pointer;
		float: right;
		margin-right: 16px;
	}

	.userinfo div:nth-child(1) {
		width: 35px;
		height: 35px;
		float: left;
	}

	.userinfo div:nth-child(1) img {
		width: 35px;
		height: 35px;
		border-radius: 50%;
	}

	.userinfo div:nth-child(2) {
		float: left;
		font-size: 18px;
		color: #4B4B4B;
		line-height: 35px;
		margin-left: 5px;
	}

	.el-icon-caret-bottom {
		font-size: 24px;
	}

	.listbut {
		text-align: center;
		width: 100%;
		height: 51px;
		line-height: 51px;
		font-size: 18px;
		color: #333131;
		border-bottom: 1px solid #eee;
		cursor: pointer;
	}

	.listbut:hover {
		background: #eee;
	}

	.el-icon-user-solid {
		color: #10DA56;
		margin-right: 5px;
		font-size: 20px;
	}

	.el-icon-s-goods {
		color: #FF0202;
		margin-right: 5px;
		font-size: 20px;
	}

	.el-icon-remove {
		color: #1072DA;
		margin-right: 5px;
		font-size: 20px;
	}

	/* 我的*/
	.upload-but {
		line-height: 16px;
		float: left;
		/* margin-top: 20px;
		margin-left: 10px; */
		width: 310px;
	}

	.upload-img {
		width: 122px;
		height: 158px;
		float: left;
		border: 1px solid #eee;
	}

	.upload-img img {
		width: 122px;
		height: 158px;

	}

	.avatar-uploader {
		width: 132px;
		float: left;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		border: 1px solid #d9d9d9;
		color: #8c939d;
		width: 140px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 122px;
		height: 158px;
		display: block;
	}
</style>
